var map = {
	"./bola.png": 107,
	"./bow.png": 108,
	"./cartao.png": 109,
	"./dancing_pig.png": 110,
	"./fartguy.png": 111,
	"./frog.png": 112,
	"./guitar_smash.png": 113,
	"./heartkey.png": 114,
	"./kiss.png": 115,
	"./knock.png": 116,
	"./laughing_girl.png": 117,
	"./notes.png": 118,
	"./water_balloon.png": 119,
	"./yawning_moon.png": 120
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 52;